import React from 'react';
import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLink = styled.a`
  font-size: 12px;
  text-decoration-color: #0783c2;
  cursor: pointer;

  &&:visited {
    color: #0783c2;
  }
  &&:hover {
    color: #0783c2;
    text-decoration: underline;
  }
  &&:active {
    color: #0783c2;
  }
`;

const ArrowImage = styled.img`
  margin-right: 8px;
  margin-left: 4px;
`;

const Lavel = styled.div`
  color: #0783c2;
`;

interface Props {
  children: any;
  onClick: any;
}

// a.k.a. CancelButton at ih-front
export const FaqResetButton = (props: Props) => {
  const { children, onClick } = props;

  return (
    <StyledLink onClick={onClick}>
      <Flex>
        <ArrowImage src="/images/left_arrow.png" alt="" />
        <Lavel>{children}</Lavel>
      </Flex>
    </StyledLink>
  );
};
